import { isDesktopHost } from '../../../../infrastructure/runtime';
import headerBackgroundDesktopImg from '../content/header/header_background_desktop.png';
import headerBackgroundMobileImg from '../content/header/header_background.png';

export function getFailDeliveryHeaderBackgroundUrl(
  desktop: boolean = isDesktopHost(),
): string {
  return desktop ? headerBackgroundDesktopImg : headerBackgroundMobileImg;
}
